<section>
  @if (loading) {
    <app-loading />
  } @else {
    <div class="add-field-row">
      <app-paired-autocomplete
        [selectedFieldControl]="addFieldControl"
        [secondaryEntityControl]="addFieldEntityControl"
        [primaryEntity]="primaryEntity"
        [componentId]="'enrichment-add-field'"
        [placeholder]="'Add a field...'"
        [entitiesOptions]="entitiesOptions"
        [dataSourceType]="dataSourceType"
        [clearInputListener]="clearAddField$"
        [overlayPositioningConfig]="overlayPositioningConfig">
      </app-paired-autocomplete>
      <mat-chip-grid #chipGrid class="selected-fields">
        @if (selectedFieldsWithLabels.length === 0) {
          <span class="empty-hint">No fields selected yet</span>
        }
        @for (item of selectedFieldsWithLabels; track item.fieldName; let i = $index) {
          <mat-chip-row @appearWidth (removed)="removeField(i)">
            {{ item.label }} ({{ item.fieldName }})
            <mat-icon matChipRemove>close</mat-icon>
          </mat-chip-row>
        }
        <input [matChipInputFor]="chipGrid" style="display:none">
      </mat-chip-grid>
    </div>
  }
</section>
